export default "__VITE_ASSET__35dee22b__"